(function () {
  'use strict';

  angular.module('eclipseApp.onboarding').directive('onboarding', Onboarding);

  function Onboarding() {
    return {
      restrict: 'E',
      scope: {
        accountDetails: '='
      },
      templateUrl: 'modules/onboarding/onboarding.view.html',
      controller: 'onboardingController',
      controllerAs: 'ctrl',
      bindToController: true
    };
  }

})();
